import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { AppInformationService } from './app-information.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { BreezeDxStoreService, CustomStore } from './breeze-dx-store.service';
import { DataService } from './data.service';
import { ArkUnitOfWork } from './data/ark-unit-of-work';
import { DocumentService } from './data/document.service';
import { EntityManagerProvider } from './data/entity-manager-provider';
import { UtilityService } from './data/utility.service';
import { ErrorInterceptor } from './error-interceptor';
import { JwtInterceptor } from './jwt.interceptor';
import { PrepareGuard } from './prepare.guard';
import { SessionInformationService } from './session-information.service';
import { ToastErrorHandler } from './toast-error-handler.service';
import { GivingService } from './data/giving.service';

export function appInitializer(authenticationService: AuthService) {
    return () =>
        new Promise((resolve: any) => {
            // attempt to refresh token on app start up to auto authenticate
            authenticationService.refreshToken().subscribe().add(resolve);
        });
}

export {
    AppInformationService,
    ArkUnitOfWork,
    AuthGuard,
    AuthService,
    BreezeDxStoreService,
    CustomStore,
    DataService,
    DocumentService,
    PrepareGuard,
    SessionInformationService,
    UtilityService,
    GivingService,
};

@NgModule({
    imports: [CommonModule, HttpClientModule],
    declarations: [],
    providers: [
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthService] },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: ErrorHandler, useClass: ToastErrorHandler },
        AppInformationService,
        PrepareGuard,
        AuthGuard,
        AuthService,
        DataService,
        SessionInformationService,
        AppInformationService,
        ArkUnitOfWork,
        EntityManagerProvider,
        BreezeDxStoreService,
        UtilityService,
        GivingService,
        DocumentService,
    ],
})
export class CoreModule {}
